export enum MenuType {
    DELETE = 'DELETE',
    EDIT = 'EDIT'
}